import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/settlementStore';
import SettlementContainer from '../containers/SettlementContainer';

// V3-owned fork of the offer document (preview modal, PDF, emailed offer).
// Forked verbatim from bundles/Settlement so V3 can evolve its offer
// math/display independently of V2 (O-3115); the only change vs the source is
// the engine swap to FinancialSummaryMath (see components/Settlement.jsx) plus
// a couple of reconciliation fixes. Kept as a faithful copy — Redux store and
// all — so nothing regresses vs what the V2 component could do. SSR-prerendered
// (registered in server-bundle.js) so the PDF/email render server-side.
const V3OfferPreviewApp = (props) => (
  <Provider store={configureStore(props)}>
    <SettlementContainer />
  </Provider>
);

export default V3OfferPreviewApp;
